import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

export const useWorkflowCardStyles = makeStyles((theme) => ({
  card: {
    marginTop: '2rem',
    padding: '2rem',
    backgroundColor: 'white',
    [theme.breakpoints.down('md')]: {
      marginTop: '16px',
      padding: '16px'
    }
  },
  label: {
    fontSize: '12px',
    color: Colors.timelineGray,
    marginBottom: 0
  },
  recipientLink: {
    fontSize: '15px',
    fontWeight: 600,
    '&:hover': {
      textDecoration: 'underline !important'
    }
  },
  recipientName: {
    paddingTop: '0.5rem',
    paddingBottom: '0.25rem'
  },
  deliveredByName: {
    fontSize: '15px',
    fontWeight: 600,
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem'
  },
  cardText: {
    fontSize: '14px',
    fontWeight: 300,
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    overflowWrap: 'anywhere'
  },
  cardTextLink: {
    fontSize: '14px',
    fontWeight: 300,
    paddingTop: '1rem',
    paddingBottom: '0.5rem',
    '&:hover': {
      textDecoration: 'underline !important'
    }
  },
  cardTextGrey: {
    fontSize: '15px',
    fontWeight: 400,
    color: Colors.midGray,
    marginBottom: '2px'
  }
}));
